import { Button } from "components/Button";
import { CloseIconSvg } from "components/icons/CloseIconSvg";
import { useTranslationContext } from "context/translation";
import { FC } from "react";
import { Image } from "react-datocms/image";
import { CompatibleMachineFragment } from "services/datocms/generated";

type CylinderCompatibilityDialogProps = {
  machines: CompatibleMachineFragment[];
  onClose: () => void;
  onOkClick: () => void;
  header?: string | null;
};

export const CylinderCompatibilityDialog: FC<
  CylinderCompatibilityDialogProps
> = ({ machines, onClose, onOkClick, header }) => {
  const { compatibleWithAllAlternativeBrandSparklingWaterMakers, gotIt } =
    useTranslationContext();

  return (
    <div className="fixed inset-0 bg-opacity-80 bg-blue-950 z-[100]">
      <div className="bg-white left-2 md:left-6 xl:left-40 right-2 md:right-6 xl:right-40 max-md:max-h-[100vh] md:top-1/2 md:-translate-y-1/2 rounded-[20px] shadow flex flex-col justify-start items-center gap-10 absolute overflow-auto">
        <div className="justify-end items-center flex gap-2.5 self-stretch">
          <div
            onClick={onClose}
            className="w-6 h-6 right-6 top-6 relative cursor-pointer"
          >
            <CloseIconSvg />
          </div>
        </div>
        {header && (
          <h1 className="text-center text-2xl leading-8 text-blue-950">
            {header}
          </h1>
        )}

        <div className="justify-center gap-6 flex flex-wrap">
          {machines.map((machine) => (
            <div
              key={machine.id}
              className="flex-col justify-start items-center gap-2 inline-flex text-center"
            >
              <div className="flex-col justify-center items-center gap-[3.66px] inline-flex">
                {machine.plpThumbnail?.responsiveImage && (
                  <Image
                    layout="responsive"
                    objectFit="contain"
                    className="max-h-[25vh] max-w-[164px]"
                    data={machine.plpThumbnail?.responsiveImage}
                  />
                )}
              </div>
              <h2 className="text-blue-950">{machine.title}</h2>
            </div>
          ))}
        </div>
        <p className="text-center text-zinc-500 text-[15px] font-medium mx-4">
          {compatibleWithAllAlternativeBrandSparklingWaterMakers}
        </p>
        <div className="mb-4">
          <Button onClick={onOkClick} size="large" className="py-4 px-9">
            {gotIt}
          </Button>
        </div>
      </div>
    </div>
  );
};
